<div class="new-contract-modal-resume">
  <div class="new-contract-modal-resume__header">
    <h2>{{ 'NEW_CONTRACT_LA.NEW_CONTRACT' | i18nextEager }}</h2>
    <span>
      <img src="/assets/icons/close.svg" (click)="closeDialog()" alt="{{ 'COMMONS.CLOSE' | i18nextEager }}" />
    </span>
  </div>
  <div class="new-contract-modal-resume__steps">
    <div *ngIf="data?.fromOffer" class="new-contract-modal-resume__step" (click)="toggletab1Offer()">
      <h2>{{ 'NEW_CONTRACT_LA.TITLE_SELECT_OFFER' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tab1Offer }" />
      </span>
    </div>
    <div *ngIf="tab1Offer">
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.OFFER' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.offer }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.OMIP' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.valorOMIP }}</span>
      </div>
    </div>
    <div *ngIf="!data?.fromOffer" class="new-contract-modal-resume__step" (click)="toggletab1Campaign()">
      <h2>{{ 'NEW_CONTRACT_LA.SELECT_VALUES' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tab1Campaign }" />
      </span>
    </div>
    <div *ngIf="tab1Campaign">
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ACCOUNT' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.traddingAccount }}</span>
      </div>
      <div *ngIf="data?.dropdownsValues?.socialReason" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.BUSINESS' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.socialReason }}</span>
      </div>
      <div *ngIf="data?.dropdownsValues?.installation" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.INSTALLATION' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.installation }}</span>
      </div>
    </div>
    <div
      *ngIf="!data?.fromOffer && data?.step > 2"
      class="new-contract-modal-resume__step"
      (click)="toggletab2Campaign()"
    >
      <h2>{{ 'NEW_CONTRACT_LA.DATA_OFFER' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tab2Campaign }" />
      </span>
    </div>
    <div *ngIf="tab2Campaign">
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.DATA_OFFER' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.CAMPAIGN' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.campaign }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.LEVEL' | i18nextEager }}</h3>
        <span>{{ data?.dataOffer?.nombreNivel }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.RENOVATE' | i18nextEager }}</h3>
        <span>{{ (data?.dataOffer?.renovacionTacita ? 'COMMONS.YES' : 'COMMONS.NO') | i18nextEager }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ELECTRIC_TAX' | i18nextEager }}</h3>
        <span>{{ (data?.dataOffer?.impuestoElectrico ? 'COMMONS.YES' : 'COMMONS.NO') | i18nextEager }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.RISK_ASSASSMENT' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.OMIP' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.valorOMIP }}</span>
      </div>
    </div>
    <div
      *ngIf="(data?.fromOffer && data?.step > 2) || (!data?.fromOffer && data?.step > 3)"
      class="new-contract-modal-resume__step"
      (click)="toggleTabHiring()"
    >
      <h2>{{ 'NEW_CONTRACT_LA.HIRING_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: tabHiring }" />
      </span>
    </div>
    <div *ngIf="tabHiring">
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.HIRIN_PERIOD' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.START_CONTRACT' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.fechaInicio | date: 'dd/MM/yyyy' }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.END_CONTRACT' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.fechaFin | date: 'dd/MM/yyyy' }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.DIRECTION' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.VIA_TYPE' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.nombreTipoViaDireccion }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.nombreDireccion }}</span>
      </div>
      <div *ngIf="data?.dataForm?.numeroDireccion && isUserSpanish" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.numeroDireccion }}</span>
      </div>
      <div *ngIf="data?.dataForm?.portalDireccion && isUserSpanish" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.portalDireccion }}</span>
      </div>
      <div *ngIf="data?.dataForm?.escaleraDireccion && isUserSpanish" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.escaleraDireccion }}</span>
      </div>
      <div *ngIf="data?.dataForm?.pisoDireccion && isUserSpanish" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.pisoDireccion }}</span>
      </div>
      <div *ngIf="data?.dataForm?.puertaDireccion && isUserSpanish" class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.puertaDireccion }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ data?.dataForm?.codPostalDireccion }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.TOWN' | i18nextEager }}</h3>
        <span>{{ data?.dropdownsValues?.townLabel }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.BANK_ACCOUNT' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3></h3>
        <span>
          {{ data?.dataForm?.iban }} {{ data?.dataForm?.entidad }} {{ data?.dataForm?.sucursal }}
          {{ data?.dataForm?.dc }} {{ data?.dataForm?.cuenta }}
        </span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3 class="black">{{ 'NEW_CONTRACT_LA.SIGNER_DATA' | i18nextEager }}</h3>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.NAME' | i18nextEager }}</h3>
        <span>{{ (data?.dataForm?.listaFirmantes)[0]?.nombreFirmante }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.SURNAME' | i18nextEager }}</h3>
        <span>{{ (data?.dataForm?.listaFirmantes)[0]?.apellidosFirmante }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.DNI' | i18nextEager }}</h3>
        <span>{{ (data?.dataForm?.listaFirmantes)[0]?.dniFirmante }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.EMAIL' | i18nextEager }}</h3>
        <span>{{ (data?.dataForm?.listaFirmantes)[0]?.mailFirmante }}</span>
      </div>
      <div class="new-contract-modal-resume__content">
        <h3>{{ 'NEW_CONTRACT_LA.PHONE' | i18nextEager }}</h3>
        <span>{{ (data?.dataForm?.listaFirmantes)[0]?.movilFirmante }}</span>
      </div>
      <ng-container *ngIf="(data?.dataForm?.listaFirmantes)[1]">
        <div class="new-contract-modal-resume__content">
          <h3 class="black">{{ 'NEW_CONTRACT_LA.SIGNER_DATA' | i18nextEager }} II</h3>
        </div>
        <div class="new-contract-modal-resume__content">
          <h3>{{ 'NEW_CONTRACT_LA.NAME' | i18nextEager }}</h3>
          <span>{{ (data?.dataForm?.listaFirmantes)[1]?.nombreFirmante }}</span>
        </div>
        <div class="new-contract-modal-resume__content">
          <h3>{{ 'NEW_CONTRACT_LA.SURNAME' | i18nextEager }}</h3>
          <span>{{ (data?.dataForm?.listaFirmantes)[1]?.apellidosFirmante }}</span>
        </div>
        <div class="new-contract-modal-resume__content">
          <h3>{{ 'NEW_CONTRACT_LA.DNI' | i18nextEager }}</h3>
          <span>{{ (data?.dataForm?.listaFirmantes)[1]?.dniFirmante }}</span>
        </div>
        <div class="new-contract-modal-resume__content">
          <h3>{{ 'NEW_CONTRACT_LA.EMAIL' | i18nextEager }}</h3>
          <span>{{ (data?.dataForm?.listaFirmantes)[1]?.mailFirmante }}</span>
        </div>
        <div class="new-contract-modal-resume__content">
          <h3>{{ 'NEW_CONTRACT_LA.PHONE' | i18nextEager }}</h3>
          <span>{{ (data?.dataForm?.listaFirmantes)[1]?.movilFirmante }}</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
